import * as React from 'react';
import styled from 'styled-components';
import { IconRow, InfoColumn, StylelessButton, Title } from './_styles';
import { changeProperty } from '@src/actions';
const FontSize = styled.div `
  margin-right: 8px;
  font-size: 18px;
`;
const changeFontSize = (size) => () => {
    changeProperty('fontSize', size);
};
const FontSizeMutator = () => (React.createElement(InfoColumn, null,
    React.createElement(Title, null, "Font size"),
    React.createElement(IconRow, null,
        React.createElement(StylelessButton, { title: "XS", onClick: changeFontSize('XS') },
            React.createElement(FontSize, null, "XS")),
        React.createElement(StylelessButton, { title: "S", onClick: changeFontSize('S') },
            React.createElement(FontSize, null, "S")),
        React.createElement(StylelessButton, { title: "M", onClick: changeFontSize('M') },
            React.createElement(FontSize, null, "M")),
        React.createElement(StylelessButton, { title: "L", onClick: changeFontSize('L') },
            React.createElement(FontSize, null, "L")),
        React.createElement(StylelessButton, { title: "XL", onClick: changeFontSize('XL') },
            React.createElement(FontSize, null, "XL")))));
export default FontSizeMutator;
